import { useEffect, useState } from 'react';

// material-ui
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { dispatch, useSelector } from 'store';
import { getLeads } from 'store/reducers/lead';
import { useAsyncDebounce } from 'react-table';
import { getEmployees } from 'store/reducers/employee';
import { Employee } from 'types/models/Employee';

interface Props{
    getFieldProps: any;
    isError?:boolean;
    onSelect:(event: any,value: any)=> void
    selected?:Employee
}


// ==============================|| AUTOCOMPLETE - ASYNCHRONOUS ||============================== //

export default function EmployeeAutoComplete({getFieldProps,onSelect,selected,isError=false}:Props) {
  const [open, setOpen] = useState(false);
  const { list } = useSelector((state) => state.employee);
  const loading = open && list.length === 0;

  useEffect(() => {
   
    
    let active = true;
    if (!loading) {
      return undefined;
    }
    (async () => {
    if (active) {
        dispatch(getEmployees({search:"",page:1,limit:100}));
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
    //   setOptions([]);
    }
  }, [open]);

  const handleSearch = useAsyncDebounce((value) => {  
    if(value?.target?.value){
      dispatch(getLeads({search:value?.target?.value,page:1,limit:100}));
    }
    // setGlobalFilter(value || undefined);
  },2000);
  return (
      <Autocomplete
        id="leads-autocomplete"
        // sx={{ width: 300 }}
      
        value={selected||null}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onInputChange={handleSearch}
        onChange={onSelect}
        // onChange={handleSearch}
        isOptionEqualToValue={(option, value) => {
           return option.id === value.id}}
        getOptionLabel={(option) => option?.full_name?? ''}
        options={list}
        filterOptions={(option)=>{
    
            return option;
            
        }}
        loading={loading}
        renderInput={(params) =>{ 
          
            
            return (
          <TextField
          {...getFieldProps}
            {...params}
            placeholder="Employee"
            fullWidth
            error={isError}
            // helperText={touched.status && errors.status}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}}
      />
  
  );
}

